"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Replaces undefined or null values with a default
 * @param value The value to check
 * @param defaultValue The value to use if 'value' is undefined or null
 */
function orDefault(value, defaultValue) {
    // Use '==' to check for both undefined and null
    return value == null ? defaultValue : value;
}
exports.orDefault = orDefault;
//# sourceMappingURL=orDefault.js.map